import { VisibleEnum, BrandsEnum } from 'types';
import * as yup from 'yup';

export const initialFormState = {
  titleAm: '',
  titleEn: '',
  titleRu: '',
}

export const createCategorySchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.'),
  titleEn: yup.string().required('Title is required.'),
  titleRu: yup.string().required('Title is required.'),
});
